import { Component, Inject, OnDestroy } from '@angular/core';
import { securityActions } from '@src/store/reducers/securityReducer';
import { Store } from '@src/store';
import { AuthService, DialogManagerService, SessionService } from '@src/services';
import { JwtHelperService } from '@auth0/angular-jwt';


@Component({
    selector: 'top-bar',
    template: require('./top-bar.component.html'),
    styles: [require('./top-bar.component.scss')]
})
export class TopBarComponent implements OnDestroy {
    public activities: any[];
    public unsubscribe: any;
    public user: any;

    constructor(
        
        private store: Store,
        @Inject('$state') private state: any,
        private authService:AuthService,
        private sessionService: SessionService,
        private dialogManagerService: DialogManagerService) {
        this.activities = [];
        this.unsubscribe = this.store.subscribe(() => {
            this.activities = this.store.getState().activities.list;
            let AuthType =  JSON.parse(localStorage.getItem("AuthType"))
            if(AuthType== 'jwt' || AuthType == 'oidc'){
                {                    
                    const storageATKey = "user_" + window.__env.config.versionRM;
                    
                    let storageKey =  JSON.parse(localStorage.getItem(storageATKey));
                    if(storageKey == null || storageKey == undefined)
                        return;

                    let token = storageKey.access_token;
                    const tokenInfo = this.getDecodedAccessToken(token);
                    this.user = tokenInfo["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"];
                    if(this.user == null || this.user == undefined)
                        this.user = tokenInfo["window.__env.config.oidcUserNameTokenKey"];
                    if(this.user == null || this.user == undefined)
                        this.user = tokenInfo["upn"];
                }
            }
            else {
                this.user = this.sessionService?.user?.username;
            }
        });
    };

    private getDecodedAccessToken(token: string): any {
        try {
            const helper = new JwtHelperService();
            const decodedToken = helper.decodeToken(token);
            return decodedToken;
        } 
        catch(Error) {
          return null;
        }
      }

    public ngOnDestroy() {
        this.unsubscribe();
    }

    public navigateToProjects() {
        this.state.go('app.authorized.projects');
    }

    public logout = () => {
        const appVersion = window.__env.config.versionRM;
        const onConfirm = () => {
            this.sessionService.remove(`user_${appVersion}`);
            let AuthType = JSON.parse(localStorage.getItem('AuthType'))
            if(AuthType == "oidc"){
                this.authService.signOutAuthentication();
            }
            else {
                this.store.dispatch({
                    type: securityActions.LOGOUT,
                    callback: () => this.state.go('app.auth.login')
                });
            }
        };
        this.dialogManagerService.showConfirmationDialog({ title: 'Logout User', action: 'logout' }, onConfirm);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/top-bar/top-bar.component.ts